export const deals = (state) => state?.entities?.deal;
